import React, { useEffect, useState } from 'react';
import { ClipboardCheck } from 'lucide-react';

/**
 * Quiet, persistent mobile action. `data-floating-corner="right"` is the existing
 * convention FloatingEdgeTabs measures, so the Knowledge Base tab lifts clear of it.
 */
const SedationStickyCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const jump = (e) => {
    const target = document.getElementById('sedation-enquiry');
    if (!target) return;
    e.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  };

  return (
    <a
      href="#sedation-enquiry"
      onClick={jump}
      data-floating-corner="right"
      data-testid="sedation-sticky-cta"
      className={`sm:hidden fixed right-4 z-[55] inline-flex items-center gap-2 rounded-full bg-[#006A71] px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_34px_-14px_rgba(0,106,113,0.85)] transition-all duration-300 motion-reduce:transition-none ${show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`}
      style={{ bottom: 'max(1.25rem, env(safe-area-inset-bottom))' }}
    >
      <ClipboardCheck className="h-4 w-4" strokeWidth={1.9} aria-hidden="true" />
      Check if sedation suits you
    </a>
  );
};

export default SedationStickyCta;
